import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AutoSaveDirective } from "./directives";
import { FileUploadControl, AutocompleteControl, OrganizationGroupControl } from "./custom-controls";
import { PrimeNgModule } from "@primeng";
import { FormStateComponent } from "./components/form-state.component";
import { ControlErrorsComponent } from "./components/control-errors.component";
import { FormButtonsComponent } from "./components/form-buttons.component";
import { LoadingDirective } from "./directives/loading.directive";
import { IfAutoSaveDisabledDirective } from "./directives/if-auto-save-disabled.directive";
import { AutoSaveIgnoreDirective } from "./directives/auto-save-ignore.directive";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LoadingComponent } from "./components/loading.component";
import { EditUserControlComponent } from "./custom-controls/edit-user-control.component";
import { FileShareControlComponent } from "./custom-controls/file-share.control";
import { NamingConventionLabelComponent } from "./components";
import { DashboardIconComponent } from "./components/dashboard-icon.component";
import { CopyValueComponent } from "./components/copy-value.component";
import { ClipboardModule } from "ngx-clipboard";
import { HistoricalDialogComponent } from "./components/historical-dialog.component";
import { GridModule } from "@features/grid";
import { PatientSelectWatchDirective } from "./directives/patient-select-watch.directive";
import { DateFilterComponent } from "./components/date-filter.component";
import { UserSuggestionControlComponent } from "./custom-controls/user-suggestion-control.component";
import { MiproModuleTitleComponent } from "./components/mipro-module-title.component";
import { DoNotPropagateClickDirective } from "./directives/do-not-propagate-click.directive";
import { FormSplitterComponent } from "./components/form-splitter.component";
import { EmptyListComponent } from "./components/empty-list.component";
import { DocumentsDialogComponent } from "./components/documents-dialog.component";
import { IconSvgComponent } from "./components/icon-svg.component";
import { UserInitialsComponent } from "./components/user-initials.component";
import { MXlScreenDirective } from "./directives/m-xl-screen.directive";
import { OfflineModule } from "@main/offline/offline.module";
import { SelectClinicianControlComponent } from "./custom-controls/select-clinician-control.component";
import { JoinPipe } from "./pipes/join.pipe";
import { NoFilterAutofocusSmDirective } from "./directives/no-filter-autofocus-sm.directive";
import { MSmScreenDirective } from "./directives/m-sm-screen.directive";
import { MomentDatePipe } from "./pipes/moment-date.pipe";
import { SafePipe } from "./pipes/safe.pipe";
import { NoAutofocusDropdownSmDirective } from "./directives/no-autofocus-dropdown-sm.directive";
import { SelectDateControlComponent } from "./custom-controls/select-date-control.component";
import { ParentRestrictedSelectDateControlComponent } from "./custom-controls/parent-restricted-select-date-control.component";
import { UserInitialsOrganisationComponent } from "./components/user-initials-organisation.component";
import { PatientReviewPromptComponent } from "@project/player/patient-review-prompt.component";
import { PatientConsentComponent } from "./custom-controls/patient-consent.component";
import { TitleControlComponent } from "./custom-controls/user-patient/title-control.component";
import { TextControlComponent } from "./custom-controls/user-patient/text-control.component";
import { DobControlComponent } from "./custom-controls/user-patient/dob-control.component";
import { GenderControlComponent } from "./custom-controls/user-patient/gender-control.component";
import { EmailControlComponent } from "./custom-controls/user-patient/email-control.component";
import { ControlGroupComponent } from "./custom-controls/user-patient/control-group.component";
import { EditPatientControlComponent } from "./custom-controls/edit-patient-control.component";
import { RequiredFieldValidatorDirective } from "./directives/required-field-validator.directive";
import { SystemCodeSwitchComponent } from "./components/system-code-switch.component";
import { WarningDialogComponent } from "./components/warning-dialog.component";
import { IM1ScreenTitleComponent } from "./components/im1-screen-title.component";
import { PatientConsentValidatorDirective } from "./custom-controls/patient-consent-validator.directive";
import { DropdownButtonComponent } from "@mipro/components/dropdown-button.component";
import { SubjectAccessRequestWarningComponent } from "@mipro/components/subject-access-request/subject-access-request-warning.component";
import { AfterLoadDirective } from "@mipro/directives/after-load.directive";
import { ColorPickerControlComponent } from "./custom-controls/color-picker-control.component";
import { ColorPickerModule } from "primeng/colorpicker";

@NgModule({
    declarations: [
        AutoSaveDirective,
        AutocompleteControl,
        FileUploadControl,
        FormStateComponent,
        ControlErrorsComponent,
        FormButtonsComponent,
        LoadingDirective,
        AfterLoadDirective,
        IfAutoSaveDisabledDirective,
        AutoSaveIgnoreDirective,
        LoadingComponent,
        EditUserControlComponent,
        FileShareControlComponent,
        NamingConventionLabelComponent,
        DashboardIconComponent,
        CopyValueComponent,
        OrganizationGroupControl,
        HistoricalDialogComponent,
        PatientSelectWatchDirective,
        DateFilterComponent,
        UserSuggestionControlComponent,
        MiproModuleTitleComponent,
        DoNotPropagateClickDirective,
        FormSplitterComponent,
        EmptyListComponent,
        DropdownButtonComponent,
        DocumentsDialogComponent,
        IconSvgComponent,
        UserInitialsComponent,
        MXlScreenDirective,
        SelectClinicianControlComponent,
        JoinPipe,
        NoFilterAutofocusSmDirective,
        MSmScreenDirective,
        MomentDatePipe,
        SafePipe,
        NoAutofocusDropdownSmDirective,
        SelectDateControlComponent,
        ParentRestrictedSelectDateControlComponent,
        UserInitialsOrganisationComponent,
        PatientReviewPromptComponent,
        TitleControlComponent,
        TextControlComponent,
        DobControlComponent,
        GenderControlComponent,
        EmailControlComponent,
        ControlGroupComponent,
        PatientConsentComponent,
        EditPatientControlComponent,
        TitleControlComponent,
        TextControlComponent,
        DobControlComponent,
        GenderControlComponent,
        EmailControlComponent,
        ControlGroupComponent,
        SystemCodeSwitchComponent,
        RequiredFieldValidatorDirective,
        WarningDialogComponent,
        IM1ScreenTitleComponent,
        PatientConsentValidatorDirective,
        SubjectAccessRequestWarningComponent,
        ColorPickerControlComponent
    ],
    exports: [
        AutoSaveDirective,
        AutocompleteControl,
        FileUploadControl,
        FormStateComponent,
        ControlErrorsComponent,
        FormButtonsComponent,
        LoadingDirective,
        AfterLoadDirective,
        IfAutoSaveDisabledDirective,
        AutoSaveIgnoreDirective,
        LoadingComponent,
        EditUserControlComponent,
        FileShareControlComponent,
        NamingConventionLabelComponent,
        DashboardIconComponent,
        CopyValueComponent,
        OrganizationGroupControl,
        HistoricalDialogComponent,
        PatientSelectWatchDirective,
        DateFilterComponent,
        UserSuggestionControlComponent,
        MiproModuleTitleComponent,
        DoNotPropagateClickDirective,
        FormSplitterComponent,
        EmptyListComponent,
        DropdownButtonComponent,
        DocumentsDialogComponent,
        IconSvgComponent,
        UserInitialsComponent,
        MXlScreenDirective,
        OfflineModule,
        SelectClinicianControlComponent,
        JoinPipe,
        NoFilterAutofocusSmDirective,
        MSmScreenDirective,
        MomentDatePipe,
        SafePipe,
        NoAutofocusDropdownSmDirective,
        SelectDateControlComponent,
        ParentRestrictedSelectDateControlComponent,
        UserInitialsOrganisationComponent,
        PatientReviewPromptComponent,
        TitleControlComponent,
        TextControlComponent,
        DobControlComponent,
        GenderControlComponent,
        EmailControlComponent,
        ControlGroupComponent,
        PatientConsentComponent,
        EditPatientControlComponent,
        TitleControlComponent,
        TextControlComponent,
        DobControlComponent,
        GenderControlComponent,
        EmailControlComponent,
        ControlGroupComponent,
        SystemCodeSwitchComponent,
        RequiredFieldValidatorDirective,
        WarningDialogComponent,
        IM1ScreenTitleComponent,
        PatientConsentValidatorDirective,
        SubjectAccessRequestWarningComponent,
        ColorPickerControlComponent
    ],
    imports: [CommonModule, PrimeNgModule, FormsModule, ReactiveFormsModule, ClipboardModule, GridModule, OfflineModule,  ColorPickerModule]
})
export class MiproSharedModule {}
